import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import {
  DefaultApiResponse,
  DefaultArg,
  transactionErrorFragment,
} from '@libs/graphql';

import {
  CalculateDirectCryotoArgs,
  CalculateDirectCrypto,
} from './calculateDirectCrypto';

export type CalculateDirectCryptoGeneralResponse = {
  calculateDirectCrypto: DefaultApiResponse<CalculateDirectCrypto>;
};

export const calculateDirectCryptoGeneralQuery: TypedDocumentNode<
  CalculateDirectCryptoGeneralResponse,
  DefaultArg<CalculateDirectCryotoArgs>
> = gql`
  query CalculateDirectCryptoGeneral($record: CalculateExchangeRecord!) {
    calculateDirectCrypto: calculateDirectCryptoGeneral(record: $record) {
      fromAssetAmount
      fromAssetAmountNoFee
      disableReset
      toAssetAmount
      toAssetAmountNoFee
      rate
      exchangeFeeId
      feeAmount
      feeRate
      error {
        ...transactionErrorFields
      }
    }
  }
  ${transactionErrorFragment}
`;
